import PrincipalModal from './PrincipalModal'

export default PrincipalModal
